import { render, staticRenderFns } from "./enteral.vue?vue&type=template&id=4be382c2&lang=pug&"
import script from "./enteral.vue?vue&type=script&lang=ts&"
export * from "./enteral.vue?vue&type=script&lang=ts&"
import style0 from "./enteral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports